var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTaiwan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 30,
    height: 24,
    rx: 4,
    ry: 4,
    fill: "#e93323"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,4H16v12H1V8c0-2.208,1.792-4,4-4Z",
    fill: "#020090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z",
    opacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z",
    fill: "#fff",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.664,8.859l-1.953-.523,1.429,1.429c.109-.339,.29-.647,.524-.906Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,8.044c.179,0,.354,.02,.523,.056l-.523-1.952-.523,1.952c.169-.036,.344-.056,.523-.056Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.741,8.163l-1.429-1.429,.523,1.953c.258-.234,.566-.415,.906-.524Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.164,8.687l.523-1.953-1.429,1.429c.339,.109,.647,.29,.906,.524Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.86,9.764l1.429-1.429-1.953,.523c.234,.258,.415,.566,.524,.906Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 10.523,
    r: 2.188,
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875,10.523l-1.952-.523c.036,.169,.056,.344,.056,.523s-.02,.354-.056,.523l1.952-.523Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.259,12.883l1.429,1.429-.523-1.953c-.258,.234-.566,.415-.906,.524Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.336,12.187l1.953,.523-1.429-1.429c-.109,.339-.29,.647-.524,.906Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,13.002c-.179,0-.354-.02-.523-.056l.523,1.952,.523-1.952c-.169,.036-.344,.056-.523,.056Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.836,12.359l-.523,1.953,1.429-1.429c-.339-.109-.647-.29-.906-.524Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14,11.282l-1.429,1.429,1.953-.523c-.234-.258-.415-.566-.524-.906Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.021,10.523c0-.179,.02-.354,.056-.523l-1.952,.523,1.952,.523c-.036-.169-.056-.344-.056-.523Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTaiwan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Taiwan.76fff06fdf09fbf2ce496737a4bac3cd.svg";